import "../style/TradeInsightsSkeleton.css";

const TradeInsightsSkeleton = () => {
  const rows = Array(4).fill(null);

  return (
    <div className="tis-wrapper">
      <div className="tis-card">
        <div className="tis-title tis-skeleton"></div>
        <div className="tis-tags">
          <div className="tis-tag tis-skeleton"></div>
          <div className="tis-tag tis-skeleton"></div>
          <div className="tis-tag tis-skeleton"></div>
        </div>

        {rows.map((_, i) => (
          <div key={i} className="tis-row">

            <div className="tis-label tis-skeleton"></div>

            <div className="tis-bar">
              <div className="tis-bar-part tis-skeleton"></div>
              <div className="tis-bar-part tis-skeleton"></div>
              <div className="tis-bar-part tis-skeleton"></div>
            </div>

            <div className="tis-info">
              <div className="tis-info-item tis-skeleton"></div>
              <div className="tis-info-item tis-skeleton"></div>
              <div className="tis-info-item tis-skeleton"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TradeInsightsSkeleton;
